import { Reducer } from 'redux';

import {
  MedicationStore,
  MedicationStoreAction,
  MedicationStoreActionTypes,
} from './types';

const initialState: MedicationStore = {
  medications: [],
  medicationNotes: [],
  isNotesLoading: false,
  noteActionStatus: { success: false, message: '', show: false },
  medicationStatusHistory: [],
  isStatusHistoryLoading: false,
  updateSuccess: false,
};

const medicationsReducer: Reducer<MedicationStore, MedicationStoreAction> = (
  state = initialState,
  action,
): MedicationStore => {
  switch (action.type) {
    case MedicationStoreActionTypes.GET_MEDICATION_SUCCESS: {
      const meds = action.payload;
      return {
        ...state,
        medications: meds,
      };
    }
    case MedicationStoreActionTypes.FETCH_MEDICATION_NOTES_SUCCESS: {
      return {
        ...state,
        medicationNotes: action.payload,
        isNotesLoading: false,
      };
    }
    case MedicationStoreActionTypes.SET_MEDICATION_NOTES_LOADING: {
      return {
        ...state,
        isNotesLoading: action.payload,
      };
    }
    case MedicationStoreActionTypes.SET_MEDICATION_NOTE_ACTION_STATUS: {
      return {
        ...state,
        noteActionStatus: action.payload,
      };
    }
    case MedicationStoreActionTypes.CLEAR_MEDICATION_NOTE_ACTION_STATUS: {
      return {
        ...state,
        noteActionStatus: initialState.noteActionStatus,
      };
    }
    // Medication Status History
    case MedicationStoreActionTypes.FETCH_MEDICATION_STATUS_HISTORY_SUCCESS: {
      return {
        ...state,
        medicationStatusHistory: action.payload,
        isStatusHistoryLoading: false,
      };
    }
    case MedicationStoreActionTypes.SET_MEDICATION_STATUS_HISTORY_LOADING: {
      return {
        ...state,
        isStatusHistoryLoading: action.payload,
      };
    }

    case MedicationStoreActionTypes.SET_UPDATE_MEDICATION_STATUS_SUCCESS: {
      return {
        ...state,
        updateSuccess: action.payload,
      };
    }
    case MedicationStoreActionTypes.RESET_UPDATE_MEDICATION_STATUS_SUCCESS: {
      return {
        ...state,
        updateSuccess: false,
      };
    }

    default:
      return state;
  }
};

export default medicationsReducer;
